// Login
//
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import { Container, Avatar, Typography, TextField, Button } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'

const Login = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const { login } = useAuth()
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isSubmitting) return

    setIsSubmitting(true)
    setError('')
    try {
      const success = await login(credentials)
      if (success) {
        navigate('/dashboard')
      } else {
        setError('No se pudo verificar la sesión. Vuelve a intentarlo.')
      }
    } catch (err) {
      const messages = {
        INVALID_CREDENTIALS: 'Credenciales incorrectas',
        LOGIN_RATE_LIMITED: 'Demasiados intentos. Espera antes de volver a intentarlo.',
        LOGIN_UNAVAILABLE: 'El servicio de autenticación no está disponible. Inténtalo más tarde.',
        LOGIN_CONNECTION: 'No se pudo conectar con el servicio de autenticación.',
        LOGIN_SESSION: 'No se pudo verificar la sesión. Revisa las cookies y vuelve a intentarlo.',
      }
      setError(messages[err?.code] || 'No se pudo iniciar sesión. Vuelve a intentarlo.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container maxWidth="xs">
      <Avatar sx={{ m: 2, bgcolor: 'primary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography variant="h5">Iniciar sesión</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          required
          label="Email"
          name="email"
          value={credentials.email}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          required
          label="Password"
          type="password"
          name="password"
          value={credentials.password}
          onChange={handleChange}
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button
          type="submit"
          disabled={isSubmitting}
          fullWidth
          variant="contained"
          sx={{ mt: 2 }}
        >
          {isSubmitting ? 'Entrando...' : 'Entrar'}
        </Button>
      </form>
    </Container>
  )
}

export default Login
